import React from "react";

import { StatusBadgeProps } from "./statusBadgeProps";

export const InterviewStatusBadge = (props: StatusBadgeProps) => {
    const { width, height = "18", viewBox = "0 0 74 18", ...rest } = props;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox={viewBox}
            {...rest}
            data-cy="interviewBadge"
        >
            <g
                fill="none"
                fillRule="evenodd"
                stroke="none"
                strokeWidth="1"
                transform="translate(-957 -10210) translate(957 10210)"
            >
                <rect
                    width="74"
                    height="18"
                    x="0"
                    y="0"
                    fill="#E35AFC"
                    rx="1.966"
                ></rect>
                <path
                    fill="#FFF"
                    fillRule="nonzero"
                    d="M6 13.137V5h1.238v8.137H6zM14.379 5h1.186v8.137h-1.25l-3.622-6.104v6.104H9.501V5h1.244l3.634 6.081V5zm5.171 8.137V6.11h-2.649V5h6.53v1.111h-2.643v7.026H19.55zm5.211 0V5h5.385v1.14H26v2.35h3.812v1.14H26v2.338h4.146v1.169H24.76zm7.228 0V5h2.51c1.538 0 2.782.852 2.782 2.35 0 1.053-.668 1.82-1.636 2.113l2.263 3.674h-1.416L34.447 9.59c-.155 0-.328.005-.495.005h-.725v3.542h-1.238zm1.25-4.555h1.37c.915-.029 1.445-.478 1.445-1.21 0-.777-.587-1.26-1.543-1.26h-1.273v2.47zM44.334 5h1.359l-3.236 8.137h-.945L38.265 5h1.37l2.356 6.15L44.335 5zm2.66 8.137V5h1.239v8.137h-1.239zm3.502 0V5h5.384v1.14h-4.146v2.35h3.812v1.14h-3.812v2.338h4.146v1.169h-5.384zm8.787 0L56.877 5h1.29l1.814 6.329 1.906-5.868h.973l1.906 5.868L66.586 5h1.284l-2.407 8.137h-1.21l-1.876-5.724-1.883 5.724h-1.21z"
                ></path>
            </g>
        </svg>
    );
};
